import React from 'react'


function PageNotFoundComponent() {
    console.log("Page Not Found")

    return (
        <>
        </>
    )
}

export default (PageNotFoundComponent);
